export enum UiSection {
    SimpleSearch = 'SimpleSearch',
    SearchResults = 'SearchResults',
    Header = 'Header',
    Upload = 'Upload'
}
